import { Button, TableColumnType } from 'antd';
import { TFunction } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';

import { Feature } from '../../../shared/models/features';
import { Batch } from '../../models/batch';
import { Order } from '../../../shared/models/order';
import { convertOrderToAntdOrder } from '../../../shared/utils/converters';
import { formatISODate } from '../../../shared/utils/date';
import { Language } from '../../../shared/models/language';

export const getColumns = (
  t: TFunction<Feature.APPROVAL>,
  language: Language,
  defaultOrder: [keyof Batch, Order],
  openPdf: (fileName: string) => void,
  processed?: boolean
): TableColumnType<Batch>[] => {
  const allColumns: TableColumnType<Batch>[] = [
    {
      title: t('batches.fileName'),
      dataIndex: 'fileName',
      sorter: true,
    },
    {
      title: t('batches.docs'),
      dataIndex: 'documents',
      sorter: false,
    },
    {
      title: t('shared.pages'),
      dataIndex: 'pages',
      sorter: false,
    },
    {
      title: t(`${Feature.SHARED}:status`),
      dataIndex: 'status',
      sorter: false,
      render: status => t(`${Feature.APPROVAL}:documentsTable.statuses.${status}`),
    },
    {
      title: t('batches.fixDate.label'),
      dataIndex: 'fixDate',
      render: (fixDate: Batch['fixDate']) => formatISODate(fixDate, language)?.slice(0, 10),
      sorter: true,
    },
    {
      title: t('batches.tenant'),
      dataIndex: 'tenant',
      sorter: true,
    },
    {
      title: t('batches.splitFrm'),
      dataIndex: 'splitFrm',
      sorter: true,
    },
    {
      title: t('batches.application'),
      dataIndex: 'application',
      sorter: true,
    },
    {
      title: t('batches.applicationGroup'),
      dataIndex: 'applicationGroup',
      sorter: true,
    },
    {
      title: t('batches.dataEntry'),
      dataIndex: 'dataEntry',
      render: (dataEntry: Batch['dataEntry']) => formatISODate(dataEntry, language)?.slice(0, 16),
      sorter: true,
    },
    {
      title: t('batches.remainingDays'),
      dataIndex: 'remainingDays',
      sorter: false,
    },
    {
      dataIndex: 'pdfLink',
      render: (pdfLink: Batch['pdfLink']) => (
        <Button type="primary" icon={<DownloadOutlined />} onClick={() => openPdf(pdfLink)}>
          {t(`${Feature.SHARED}:view`)}
        </Button>
      ),
      width: 100,
    },
  ];

  const columns = processed ? allColumns.filter(col => col.dataIndex !== 'remainingDays') : allColumns;

  columns.forEach(column => {
    if (column.dataIndex === defaultOrder[0]) {
      column['defaultSortOrder'] = convertOrderToAntdOrder(defaultOrder[1]);
    }
  });

  return columns;
};
